import ServiceGraphQL from 'src/service/gql-service';
import { acceptInvitation } from 'src/graphql';

const serviceGraphQL = new ServiceGraphQL();

/** Action creators */
export const AcceptInvitation = (data) => {
  const params = {
    query: acceptInvitation.QUERY,
    variables: {
      company: data
    }
  };
  return serviceGraphQL
    .post(params)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};
